<template>
  <div class="banner-editor-split-view">
    <div
      class="editor-preview-container"
      v-if="item">
      <div class="preview-header-container">
        <h5 class="name"><i class="fas fa-edit"></i> แก้ไขสไลด์</h5>
        <BackgroundImageChooser
          :image.sync="item.coverImage">
          <span slot="button-text">เปลี่ยนภาพปก</span>
        </BackgroundImageChooser>
      </div>
      <SliderItem
        v-if="item.coverImage"
        :data="item"
        :thumborSize="item.coverImage.urls.content1920w ? 'content1920w' : 'cover1280w720h'"/>
      <SliderItem
        v-if="!item.coverImage"
        :data="item"/>
    </div>
    <div
      :style="item.parentId ? '' : 'margin-top: 8px'"
      class="editor-metadata-container"
      v-if="item">
      <div class="row">
        <div class="col-md-12">
          <FormGroup
            v-if="item.parentId">
            <div class="btn-group btn-group-custom" role="group">
              <button
                type="button"
                @click="makeSyncWithParent"
                :class="{'is-selected' : item.syncWithParent }"
                class="btn btn-outline-dark">
                ใช้ค่าเดิม
              </button>
              <button
                type="button"
                @click="makeCustom"
                :class="{'is-selected' : !item.syncWithParent }"
                class="btn btn-outline-dark">
                ตั้งค่าเอง
              </button>
            </div>
          </FormGroup>
          <FormGroup>
            <h5 class="name">ข้อความ</h5>
            <input
              type="text"
              class="form-control"
              v-model="item.title"
              :disabled="item.syncWithParent"/>
          </FormGroup>
          <FormGroup>
            <h5 class="name">หมวดหมู่คอนเทนท์</h5>
            <SelectOptionObject
              :value="item.contentCategory"
              :options="contentCategories"
              :disabled="item.syncWithParent"
              @onChanged="onSelectedContentCategory"/>
          </FormGroup>
          <FormGroup>
            <h5 class="name">ลิงก์</h5>
            <input
              type="text"
              class="form-control"
              :disabled="item.syncWithParent"
              v-model="item.link.url"/>
            <div class="form-check form-check-inline">
              <input
                id="checkBoxNewTab"
                class="form-check-input"
                type="checkbox"
                value="_blank"
                v-model="item.link.target">
              <label
                class="form-check-label"
                for="checkBoxNewTab">
                &nbsp; เปิดลิงก์ในแท็บใหม่
              </label>
            </div>
          </FormGroup>
          <FormGroup>
            <p>เริ่มต้นการเผยแพร่</p>
            <div class="form-group-publish-date">
              <DateTimePicker
                placeholder="เลือกวันที่เริ่มต้น"
                v-model="item.startPublish"/>
            </div>
            <p>สิ้นสุดการเผยแพร่</p>
            <div class="form-group-publish-date">
              <DateTimePicker
                placeholder="เลือกวันที่สิ้นสุด"
                v-model="item.endPublish"
                @dateChanged="onDateChanged" />
            </div>
            <div
              class="alert alert-danger"
              v-if="timeMachine">
              <p>คุณไม่สามารถตั้งวันสิ้นสุดก่อนวันเริ่มต้นได้</p>
            </div>
            <button
              v-if="item.endPublish"
              class="btn btn-light"
              @click="resetDate">
              ไม่กำหนดวันสิ้นสุด
            </button>
          </FormGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// APIs
import { loadVideoByKey } from '@/video/api';
import { loadEpisodeById } from '@/episode/api';
import { loadProgramByKey } from '@/program/api';
import { loadTaxonomyByKey } from '@/taxonomy/api';
// System
import FormGroup from '@/components/FormGroup.vue';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import DateTimePicker from '@/components/DateTimePicker.vue';

// Custom
import SliderItem from '@/pageDesigner/slider/SliderItem.vue';
import SliderMixins from '@/pageDesigner/mixins';
import BackgroundImageChooser from '../../BackgroundImageChooser.vue';

export default {
  mixins: [SliderMixins],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    FormGroup,
    SelectOptionObject,
    DateTimePicker,
    BackgroundImageChooser,
    SliderItem,
  },
  data() {
    return {
      timeMachine: false,
      contentCategories: [],
    };
  },
  mounted() {
    this.loadContentCategories();
  },
  methods: {
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategories = response.data.data;
    },
    onSelectedContentCategory(selectedOption) {
      if (selectedOption) {
        this.item.contentCategory = selectedOption;
      } else {
        this.item.contentCategory = null;
      }
    },
    async restoreSyncedData() {
      let response;
      switch (this.item.parentType) {
        case 'programs':
          response = await loadProgramByKey(this.item.parentId);
          break;
        case 'episodes':
          response = await loadEpisodeById(this.item.parentId);
          break;
        case 'videos':
          response = await loadVideoByKey(this.item.parentId);
          break;
        case 'podcasts':
          response = {
            data: {
              data: [],
              lastPage: 1,
            },
          };
          break;
        default:
          return;
      }
      this.item.title = response.data.title;
      this.item.contentCategory = response.data.contentCategory;
      this.item.link.url = response.data.url;
      this.item.startPublish = response.data.startPublish;
      this.item.endPublish = response.data.endPublish ? response.data.endPublish : null;
    },
    makeSyncWithParent() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (!this.item.syncWithParent && confirm('คุณต้องการลบค่าที่ตั้งเอง แล้วเรียกใช้ข้อมูลจากระบบใช่หรือไม่')) {
        this.item.syncWithParent = true;
        this.restoreSyncedData();
      }
    },
    makeCustom() {
      this.item.syncWithParent = false;
    },
    resetDate() {
      this.item.endPublish = null;
    },
    onDateChanged(pickedDate) {
      const unixTime = pickedDate.getTime();
      if (unixTime === -25200000) {
        return;
      }
      if (this.tryToMakeTimeMachine(this.item.startPublish, pickedDate)) {
        this.timeMachine = true;
        this.resetDate();
      } else {
        this.timeMachine = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/themes/components/manage-metadata.scss';

</style>
